import CityPageTemplate from "../city-template/CityPageTemplate";
import { fallsChurchVaConfig } from "./data";

export default function FallsChurchVaPage() {
  return <CityPageTemplate config={fallsChurchVaConfig} />;
}